import React, { createContext, useState } from "react";

interface CreateActionContextType {  
  backendFormErrors: any;
  setBackendFormErrors: (backendFormErrors: any) => void;  
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
  element: any;
  setElement: (element: any) => void;
  selectedLang: string;
  setSelectedLang: (selectedLang: string) => void;
  attributes: any[],
  setAttributes: (attributes: any) => void;
  commercePrice: number
  setCommercePrice: (price: number) => void
  adjustmentError: any;
  setAdjustmentError: (error: any) => void;
}

export const CreateActionContext = createContext<CreateActionContextType>({  
  backendFormErrors: {},
  setBackendFormErrors: () => {},
  showModal: false,
  setShowModal: () => {},
  element: null,
  setElement: () => {},
  selectedLang: "",
  setSelectedLang: () => {},
  attributes: [],
  setAttributes: () => {},
  commercePrice: 0,
  setCommercePrice: () => {},
  adjustmentError: null,
  setAdjustmentError: () => {},
});

interface CreateActionProviderProps {
  children: React.ReactNode;
}

export const CreateActionProvider: React.FC<CreateActionProviderProps> = ({
  children,
}) => {  
  const [backendFormErrors, setBackendFormErrors] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [element, setElement] = useState<any>(null);
  const [selectedLang, setSelectedLang] = useState<string>("");
  const [attributes, setAttributes] = useState<any[]>([]);
  const [commercePrice, setCommercePrice] = useState<number>(0);
  const [adjustmentError, setAdjustmentError] = useState<any>(null);

  const value = {    
    backendFormErrors,
    setBackendFormErrors,
    showModal,
    setShowModal,
    element,
    setElement,
    selectedLang,
    setSelectedLang,
    attributes,
    setAttributes,
    commercePrice,
    setCommercePrice,
    adjustmentError,
    setAdjustmentError
  };
  return (
    <CreateActionContext.Provider value={value}>
      {children}
    </CreateActionContext.Provider>
  );
};
